module.exports = {"150429100":"天义镇","150429101":"小城子镇","150429102":"大城子镇","150429103":"八里罕镇","150429104":"黑里河镇","150429105":"右北平镇","150429106":"大双庙镇","150429107":"汐子镇","150429108":"大明镇","150429109":"忙农镇","150429110":"五化镇","150429111":"三座店镇","150429112":"必斯营子镇","150429202":"一肯中乡","150429203":"存金沟乡","150429400":"中京工业园","150429401":"塞飞亚食品工业园","150429402":"八里罕酒业园区","150429403":"再生资源产业园","150429404":"生物科技产业园区","150429405":"汐子工业园","150429406":"农机产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150429.json
// module id = 425
// module chunks = 0